import colors from './colors';

export interface Shadows {
  /** @return 'none' */
  0: string;
  /** @return '10px 10px 0 0 rgba(0, 0, 0, 0.3)' */
  10: string;
  /** @return '15px 15px 0 0 rgba(0, 0, 0, 0.3)' */
  15: string;
  /** @return '20px 20px 0 0 rgba(0, 0, 0, 0.3)' */
  20: string;
  /** @return `4px 4px 0 ${colors.coolGrey[20]}` */
  cardList: string;
  /** @return `8px 8px 0 ${colors.coolGrey[20]}` */
  cardListHover: string;
  /** @return `2px 2px 4px ${colors.coolGrey[20]}` */
  cardTextOnly: string;
  /** @return '0 0 5px 0 rgba(0, 0, 0, 0.1)' */
  listItem: string;
  /** @return '0px -4px 8px rgba(40, 44, 51, 0.15)' */
  video: string;
}

const shadows: Shadows = {
  0: 'none',
  10: '10px 10px 0 0 rgba(0, 0, 0, 0.3)',
  15: '15px 15px 0 0 rgba(0, 0, 0, 0.3)',
  20: '20px 20px 0 0 rgba(0, 0, 0, 0.3)',
  cardList: `4px 4px 0 ${colors.coolGrey[20]}`,
  cardListHover: `8px 8px 0 ${colors.coolGrey[20]}`,
  cardTextOnly: `2px 2px 4px ${colors.coolGrey[20]}`,
  listItem: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
  video: '0px -4px 8px rgba(40, 44, 51, 0.15)'
};

export default shadows;
